import script from "./CheckoutPickUpDeliverableSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutPickUpDeliverableSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutPickUpDeliverableSkeleton.vue?vue&type=style&index=0&id=2cab63eb&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cab63eb"]])

export default __exports__